/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Category_LabelInputs */

const en_directory_vibebids_category_label = /** @type {(inputs: Directory_Vibebids_Category_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category`)
};

const zh_directory_vibebids_category_label = /** @type {(inputs: Directory_Vibebids_Category_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分类`)
};

/**
* | output |
* | --- |
* | "Category" |
*
* @param {Directory_Vibebids_Category_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_category_label = /** @type {((inputs?: Directory_Vibebids_Category_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Category_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_category_label(inputs)
	return zh_directory_vibebids_category_label(inputs)
});
export { directory_vibebids_category_label as "directory.vibebids.category_label" }